import { media } from "src/styles/mixins";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "src/images/close-icon.svg";
import TextareaInput from "src/components/shared/Inputs/TextareaInput";

export const ContactModalHeading = styled.h2`
  margin-bottom: 35px;
`;

export const ContactForm = styled.form`
  width: 50vw;

  ${media.down("TABLET")`
    width: 100%;
  `}

  input:not([type="checkbox"]) {
    width: 60%;

    ${media.down("LAPTOP")`
      width: 100%;
    `}
  }

  textarea {
    width: 100%;
    height: 180px;
  }

  a {
    color: ${({ theme }) => theme.colors.link};
  }
`;

export const ContactModalButtons = styled.div`
  text-align: center;
  margin-top: 36px;

  button {
    width: 100%;

    ${media.up("LAPTOP")`
      width: 208px;
    `}
  }
`;

export const ContactModalCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 36px;
  right: 15px;
  cursor: pointer;

  ${media.up("LAPTOP")`
    right: 36px;
  `}
`;

export const ContactModalTextArea = styled(TextareaInput)`
  resize: vertical;
`;
